import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { objectNotNullV2 } from '@/Utils/FnUtils';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { handleResponseThrowError } from '@/_utils/services';
import { GET_MOTOBOYS } from '../constants';
import type { IMotoboyNames } from '../types';

type ParamsProps = {
  nameDeliveryMan?: string;
  municipioId?: string;
};

const getMotoboys = (params: ParamsProps) => {
  const { nameDeliveryMan, municipioId } = params || {};

  return apiClientOld
    .get<IMotoboyNames[]>('entregadores/name', {
      params: objectNotNullV2({
        nomeEntregador: nameDeliveryMan,
        municipioId,
      }),
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetMotoboysData = Awaited<ReturnType<typeof getMotoboys>>;

export const useGetMotoboys = (
  params: ParamsProps,
  options: Omit<
    UseQueryOptions<
      GetMotoboysData,
      unknown,
      GetMotoboysData,
      (string | ParamsProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_MOTOBOYS, params],
    queryFn: () => getMotoboys(params),
    ...options,
  });
};
